import './loader.scss';


export const BallBeat = (props) => {
    return (
        <div className="ball-loader" >
            <div className="ball-loader-ball ball1" style={{ backgroundColor: props.color }}></div>
            <div className="ball-loader-ball ball2" style={{ backgroundColor: props.color }}></div>
            <div className="ball-loader-ball ball3" style={{ backgroundColor: props.color }}></div>
        </div>
    )

}

export const Spinner = ({ color = '#f75891', size = 20 }) => (
    <span
        style={{
            display: 'inline-block',
            width: size,
            height: size,
            border: `2.5px solid rgba(247, 88, 145, 0.25)`,
            borderTopColor: color,
            borderRadius: '50%',
            animation: 'spinner-spin 0.65s linear infinite',
            verticalAlign: 'middle',
        }}
    />
);

export const ThreeDots = (props) => {
    return (
        <div className="three-dots">
            <div className="loader" id="loader-4">
                <span style={{ background: props.color || '#F75891' }}></span>
                <span style={{ background: props.color || '#F75891' }}></span>
                <span style={{ background: props.color || '#F75891' }}></span>
            </div>
        </div>
    )
}